import styled from "styled-components";

export const ListWrapper = styled.section`
  padding: 50px 0 50px 0;
  min-height: 100%;

  body#grid & {
    display: grid;
    grid-area: posts;
    grid-gap: 1px;
    grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  }
`;
